export default {
    bloglist: {
        en: [
            {
                title: 'Send Messages to Unsaved Numbers in GB WhatsApp',
                poster: require('@/assets/blog-1.webp'),
                desc: "Learn to send messages to unsaved numbers in GB WhatsApp. Improve business communication, streamline customer support, and maintain privacy while using the app safely and efficiently.",
                name: 'en-send-messages-to-unsaved-numbers-gbwhatsapp',
                url: '/send-messages-to-unsaved-numbers-gbwhatsapp/',
                date: "2025-12-19",
            },
            {
                title: 'How to Use Two WhatsApp Accounts with GBWhatsApp',
                poster: require('@/assets/blog-cover.png'),
                desc: "A complete guide on running dual WhatsApp accounts on a single Android device using GBWhatsApp. Step-by-step instructions and tips.",
                name: 'en-how-to-use-two-whatsapp-accounts-with-gbwhatsapp',
                url: '/how-to-use-two-whatsapp-accounts-with-gbwhatsapp/',
                date: "2026-05-11",
            },
            {
                title: 'Can You Use GBWhatsApp Without Getting Banned?',
                poster: require('@/assets/blog-cover.png'),
                desc: "Discover the truth about GBWhatsApp bans. Learn practical tips, anti-ban features, and safe usage practices to protect your account.",
                name: 'en-can-you-use-gbwhatsapp-without-getting-banned',
                url: '/can-you-use-gbwhatsapp-without-getting-banned/',
                date: "2026-05-11",
            },
            {
                title: 'Why Some GBWhatsApp Versions Stop Working Suddenly',
                poster: require('@/assets/blog-cover.png'),
                desc: "Find out why your GBWhatsApp suddenly stopped working. We explain the common causes like forced updates, expired versions, and how to fix them.",
                name: 'en-why-some-gbwhatsapp-versions-stop-working-suddenly',
                url: '/why-some-gbwhatsapp-versions-stop-working-suddenly/',
                date: "2026-05-11",
            },
            {
                title: 'How to Recover Deleted Messages in GB WhatsApp (2026)',
                poster: require('@/assets/blog-recover-deleted-messages.webp'),
                desc: "Recover deleted messages in GB WhatsApp by enabling the Anti-Delete Messages feature. View messages even after the sender deletes them.",
                name: 'en-recover-deleted-messages-gb-whatsapp',
                url: '/recover-deleted-messages-gb-whatsapp/',
                date: "2026-07-24",
            },
            {
                title: 'How to Change DP Photo Corners in GB WhatsApp (2026)',
                poster: require('@/assets/blog-dp-photo-corners.webp'),
                desc: "Learn how to change DP Photo Corners in GB WhatsApp by opening GB Settings > Universal > DP Photo Corners, selecting your preferred style, and saving the changes.",
                name: 'en-change-dp-photo-corners-gb-whatsapp',
                url: '/change-dp-photo-corners-gb-whatsapp/',
                date: "2026-07-24",
            },
            {
                title: 'Is GB WhatsApp Safe to Use? Security and Privacy Risks',
                poster: require('@/assets/blog-gb-whatsapp-safe-to-use.webp'),
                desc: "Is GB WhatsApp safe to use? Learn about its security, privacy, account ban risks, APK downloads, and what to consider before installing it.",
                name: 'en-is-gb-whatsapp-safe-to-use',
                url: '/is-gb-whatsapp-safe-to-use/',
                date: "2026-08-11",
            }
        ],
    }
}
